import { render, staticRenderFns } from "./SolarCellViz.vue?vue&type=template&id=6bf71ff2&scoped=true"
import script from "./SolarCellViz.vue?vue&type=script&lang=js"
export * from "./SolarCellViz.vue?vue&type=script&lang=js"
import style0 from "./SolarCellViz.vue?vue&type=style&index=0&id=6bf71ff2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf71ff2",
  null
  
)

export default component.exports